import {createSlice} from "@reduxjs/toolkit";
import {SearchButtonLabelViewModelType} from "../../../../components/search/SearchButtonUI";

type StateType = {
  searchData: {
    buttonLabelViewModel: SearchButtonLabelViewModelType | undefined;
  };
};

const initialState: StateType = {
  searchData: {
    buttonLabelViewModel: undefined,
  },
};

export const SearchDataSlice = createSlice({
  name: "searchData",
  initialState,
  reducers: {
    setSearchButtonLabel(
      state,
      action: {payload: SearchButtonLabelViewModelType | undefined},
    ) {
      state.searchData.buttonLabelViewModel = action.payload;
    },
  },
});

export const {setSearchButtonLabel} = SearchDataSlice.actions;
export default SearchDataSlice.reducer;
